export default {
	delete: 'bulk_delete',
	invite: 'bulk_invite',
	tag: 'bulk_tag',
};
